import React from 'react';

import styles from './FeatureCard.module.scss';

export interface FeatureCardProps {
  icon: string;
  description: string;
  backgroundColor: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ icon, description, backgroundColor }) => {
  return (
    <article className={styles.card}>
      <div className={styles.icon} style={{ backgroundColor }}>
        <img loading="lazy" src={icon} alt="" width={32} height={32} className={styles.image} />
      </div>
      <p className={styles.description}>{description}</p>
    </article>
  );
};
